//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from "@/const/const"
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "FreightPriceResult",
    components: {
        MyBtnReturn
    },
    data() {
        return {
            tableData: [
                // {
                //   priceType: '20GP',
                //   pricePortLoading: '广州',
                //   priceDockLoading: '上海',
                //   totalup: '￥3000.23',
                //   priceGoodsName: '石油',
                //   priceCarriageItem: 'DR-DR(门-门)',
                //   priceConsigneeJhr: '广州市海珠区建南1',
                //   priceConsigneePlace: '广州市海珠区江南西',
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false,
            tableDataUrl: '', // 查询表单数据API，freightPriceTemplate
        }
    },
    created() {
        document.title = '全程运输报价查询';
        this.tableDataUrl = apiUrl.freightPriceTemplate
    },
    mounted() {
        // 要在这个钩子函数中才能一开始操作到scrollBottom标签
        this.onScrollBottom()
    },
    methods: {
        getMoreData(url, data) {
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle',
                    type: 'text'
                });
                return
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data.page;
                let resultArr = dataObj.result || []; // 防止后台返回null
                if (resultArr.length === 0) {
                    // 如果没有数据，要告知用户（不在第一个if加上this.pageNo === 1，是怕后台莫名其妙传完[]）
                    this.isNoData = true;
                    this.isShowLoading = false;
                    // 如果是第一页就没有数据，那隐藏scroller吧
                    if (this.pageNo === 1) {
                        this.isShowTable = false
                    }
                    return
                }
                resultArr.forEach((item) => {
                    this.tableData.push(item)
                }); // 表格数据是放在result中
                this.totalCount = dataObj.totalCount;
                this.totalPages = dataObj.totalPages;
                this.pageNo++;
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset() // 一开始不能v-if隐藏scrollBottom标签，否则这里获取不到scrollBottom标签
                }) // 要重置scroller组件
            }, (error) => {
                this.isShowLoading = false;
                this.canFetch = true;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        onScrollBottom() {
            if (!this.canFetch) {
            } else {
                this.isShowLoading = true;
                this.canFetch = false;
                let query = this.$route.query;
                let data = {
                    place_loading: query.place_loading,
                    place_delivery: query.place_delivery,
                    group: query.group,
                    shipper: query.shipper,
                    pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                    pageNo: this.pageNo, // 当前为第几页数据，要累加
                    openId: apiParams.openId,
                    companyId: apiParams.companyId,
                    code: apiParams.code,
                };
                this.getMoreData(this.tableDataUrl, data)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/kehu/freightPrice/FreightPriceResult.vue